<template>
  <div :style="{ padding: `${padding}px` }">
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>Side icon / Phone</title>
      <defs>
        <path
          id="phone"
          d="M15.598,16.5 C15.8473333,16.5 16.06,16.412 16.236,16.236 C16.412,16.06 16.5,15.8473333 16.5,15.598 L16.5,15.598 L16.5,12.364 C16.5,12.1146667 16.412,11.902 16.236,11.726 C16.06,11.55 15.8473333,11.462 15.598,11.462 C14.3953333,11.462 13.31,11.2933333 12.342,10.956 C12.1806667,10.8826667 12.012,10.868 11.836,10.912 C11.66,10.956 11.5133333,11.044 11.396,11.176 L11.396,11.176 L9.372,13.2 C8.08133333,12.5253333 6.91533333,11.6673333 5.874,10.626 C4.83266667,9.58466667 3.97466667,8.41866667 3.3,7.128 L3.3,7.128 L5.39704,5.03008 C5.48621333,4.92682667 5.54253333,4.8048 5.566,4.664 C5.59533333,4.488 5.588,4.31933333 5.544,4.158 C5.20666667,3.19 5.038,2.10466667 5.038,0.902 C5.038,0.652666667 4.95,0.44 4.774,0.264 C4.598,0.088 4.38533333,0 4.136,0 L4.136,0 L0.902,0 C0.652666667,0 0.44,0.088 0.264,0.264 C0.088,0.44 0,0.652666667 0,0.902 C0,3.014 0.410666667,5.038 1.232,6.974 C2.024,8.83666667 3.13866667,10.4866667 4.576,11.924 C6.01333333,13.3613333 7.66333333,14.476 9.526,15.268 C11.462,16.0893333 13.486,16.5 15.598,16.5 Z"
        ></path>
      </defs>
      <g id="Side-icon-/-Phone" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Mask/LS_Green" transform="translate(4.000000, 4.000000)">
          <mask id="mask-phone" fill="white"><use xlink:href="#phone"></use></mask>
          <use id="Mask" fill="#0AB463" fill-rule="nonzero" xlink:href="#phone"></use>
          <g id="Group" mask="url(#mask-phone)">
            <g transform="translate(-4.000000, -4.000000)">
              <rect id="Rectangle" :fill="color" x="0" y="0" :width="size" :height="size"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'PhoneSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
    padding: VueTypes.number.def(0),
  },
};
</script>

<style lang="scss" scoped>
div {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
